import {IntermediatePart} from "../../intermediatePart";
import {Vanity} from "../../parts/vanity";
import {createParentPositions, SIDE_POSITIONS, VANITY_TYPES, LOOK_ROOM_TYPES} from "../../constants";
import {removeLookPointFor} from "../../../lookNavigation/lookFunctions2";
import {getCurrentRoomType} from "../../../../appLayout";

export default class VanityLegs extends IntermediatePart {

  constructor(isChild) {
    super(isChild);
    this.partId = 'vanity_legs';
    this.partName = 'Vanity Legs';
    this.translateId = "visualizer.bathroom.vanity.vanity_legs";
    this.visible = [Vanity.Types.Custom];
    this.canBeDisabled = true;
    if (isChild) {
      createParentPositions(this);
    }
  }

  disabledClick() {
    this.toggleLayerPositions();
  }

  hideLayerCondition() {
    const vanityParent = this.getParent();
    return !vanityParent.vanityCabinet || !vanityParent.vanityCabinet.activeFeature || vanityParent.vanity_type !== VANITY_TYPES.vanity_cabinet
  }

  getArrayOfConditions() {
    const conditions = super.getArrayOfConditions();
    const vanityParent = this.getParent();
    const activeMatchingVanity = vanityParent.getActiveSkuFromRelatedItem("vanity_cabinet");
    if (activeMatchingVanity) {
      conditions.push({
        propName: "MatchingFeature",
        propValue: activeMatchingVanity
      });
    }
    const activeSideMeta = vanityParent.getActiveMatchingMetaFromRelatedItem("vanity_cabinet", "Side");
    if (activeSideMeta && activeSideMeta.includes("C")) {
      conditions.push({
        propName: "Side",
        propValue: activeSideMeta
      });
    }
    return conditions
  }

  canDisplayDemoPoint(parentObject) {
    if (getCurrentRoomType() === LOOK_ROOM_TYPES.as) {
      return parentObject.layerPosition !== SIDE_POSITIONS[0] && removeLookPointFor(parentObject, 6, "1")
    }
    return this.getParent().vanity_type === VANITY_TYPES.vanity_cabinet
  }

}
